
import { Injectable } from '@angular/core';
import { AuxiliumSocketClient } from '@auxilium/socket-client';
import { startWith } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root'
})
export class SocketService extends AuxiliumSocketClient {

	// ready = new ReplaySubject<void>();

	constructor(
		api: ApiService,
	) {
		super(environment.socket);

		api.token
			.pipe(
				startWith(api.getToken()),
			)
			.subscribe(t => {
				this.resume(t, api.spoke);
			});
	}
}

